const MyStepTypes = {

    FETCH_MYSTEP_DETAILS: {
        SUCCESS: 'FETCH_MYSTEP_DETAILS_SUCCESS',
        FAILURE: 'FETCH_MYSTEP_DETAILS_FAILURE',
        PENDING: 'FETCH_MYSTEP_DETAILS_PENDING',
    },

    FETCH_REPORT: {
        SUCCESS: 'FETCH_REPORT_SUCCESS',
        FAILURE: 'FETCH_REPORT_FAILURE',
        PENDING: 'FETCH_REPORT_PENDING',
    },


}

export default MyStepTypes;